import { Box, Paper, TextField, Typography } from "@material-ui/core";
import { RouteComponentProps } from "@reach/router";
import { useEffect } from "react";
import { useState } from "react";
import { AdminUserDetailsResponse } from "@authory-packages/core";
import { Api } from "../lib/api";
import { Layout } from "./Layout";
import { ComponentLoadingIndicator } from "../components/ComponentLoadingIndicator";
import { BulkImportPanel } from "../components/BulkImportModal";
import { UserDetailsSummary } from "../components/UserDetailsSummary";
import { CreateNewSourceModal } from "../components/CreateNewWebsiteModa";
import { UserDataPanel } from "../components/UserDataPanel";
import { SourceManager } from "../components/SourceDetails/SourceManager";
import { useHotkeys } from "react-hotkeys-hook";
import { format } from "date-fns";

export interface UserListpageProps
  extends RouteComponentProps<{ userSlug: string }> {}

export const UserDetailsPage = ({ userSlug }: UserListpageProps) => {
  const [userDetails, setUserDetails] = useState<AdminUserDetailsResponse>();
  const [bulkImportOpen, setBulkImportOpen] = useState(false);
  const [createSourceModalOpen, setCreateSourceModalOpen] = useState(false);

  const opts: any = {
    enableOnTags: ["INPUT", "TEXTAREA", "SELECT"],
  };

  useHotkeys("ctrl+q", (e) => setCreateSourceModalOpen(true), opts);
  useHotkeys("⌘+q", (e) => setCreateSourceModalOpen(true), opts);

  const fetchData = async () => {
    if (!userSlug) return;

    Api.getUser(userSlug).then((res) => setUserDetails(res.data));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Layout title={`User - ${userSlug} ${userDetails?.stage}`}>
      <UserDetailsSummary
        userDetails={userDetails}
        userSlug={userSlug}
        onBulkImportClick={() => setBulkImportOpen(true)}
        onCreateSourceClick={() => setCreateSourceModalOpen(true)}
        onUserChangeStatus={() => fetchData()}
      />
      <Box mt={2}>
        <Typography variant="h6" color="primary">
          URL
        </Typography>
      </Box>
      <Box component={Paper} padding={2}>
        <form action="/urls" noValidate autoComplete="off" target="_blank">
          <TextField fullWidth label="Search URL" name="urlSearch" />
          <input type="hidden" name="mainSearch" value={userSlug} />
          <input type="submit" hidden />
        </form>
      </Box>
      <ComponentLoadingIndicator isLoading={!userSlug || !userDetails}>
        {userSlug && userDetails && (
          <SourceManager
            userSlug={userSlug}
            userWebsites={userDetails.sources || []}
            user={userDetails}
            onSourceDeleted={fetchData}
          />
        )}
      </ComponentLoadingIndicator>
      <Box mt={2}>
        <Typography
          variant="h6"
          color="primary"
          display="inline"
          style={{ marginRight: 10 }}
        >
          User Data
        </Typography>
        {!!userDetails?.paymentSubscription?.nextBillingAt && (
          <Typography variant="body1" display="inline">
            Next billing at:{" "}
            {`${format(
              new Date(userDetails?.paymentSubscription.nextBillingAt),
              "dd MMM yyyy"
            )}`}
          </Typography>
        )}
      </Box>
      <Box component={Paper} padding={2}>
        <UserDataPanel
          userDetails={userDetails}
          userSlug={userSlug}
          onDataSaved={(data: AdminUserDetailsResponse) => setUserDetails(data)}
        />
      </Box>
      {bulkImportOpen && !!userSlug && (
        <BulkImportPanel
          open={true}
          userSlug={userSlug}
          onClose={() => setBulkImportOpen(false)}
          onImportFinished={() => fetchData()}
        />
      )}
      {createSourceModalOpen && !!userSlug && (
        <CreateNewSourceModal
          open={true}
          userSlug={userSlug}
          onClose={() => setCreateSourceModalOpen(false)}
          onSourceCreated={() => fetchData()}
        />
      )}
    </Layout>
  );
};
